<template>
  <!-- Based on https://blog.xn&#45;&#45;antnio-dxa.pt/vue-password-hide-show-with-vue-formulate-->
  <div :class="elemClasses" :data-type="context.type">
    <!-- eslint-disable vue/no-mutating-props -->
    <input
      :id="context.id"
      v-model="context.node._value"
      :name="context.node.name"
      :type="showPassword ? 'text' : 'password'"
      :disabled="context.disabled as boolean"
      autocomplete="no"
      v-bind="context.attrs"
      class="border-none! grow !focus:ring-0 shadow-none outline-none"
      :class="context.classes.input"
      @blur="context.handlers.blur"
      @input="context.handlers.DOMInput"
    />
    <button
      type="button"
      class="icon-button"
      @click="showPassword = !showPassword"
    >
      <!--suppress HtmlUnknownTag -->
      <div class="pr-2 opacity-30">
        <EyeIcon v-show="!showPassword" />
        <CrossedEyeIcon v-show="showPassword" />
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { FormKitFrameworkContext } from '@formkit/core'
import { defineComponent } from 'vue'
import EyeIcon from '~/../member-webapp-shared/components/icons/figma/EyeIcon.vue'
import CrossedEyeIcon from '~/../member-webapp-shared/components/icons/figma/CrossedEyeIcon.vue'

export default defineComponent({
  components: { CrossedEyeIcon, EyeIcon },
  props: {
    context: {
      type: Object as PropType<FormKitFrameworkContext>,
      required: true,
    },
  },
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    elemClasses() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return `input-wrapper ${this.context.classes.outer}`
    },
  },
})
</script>
